'use client'

import Link from 'next/link'
import { Button } from '@/components/ui/button'

export default function PurchaseButtonContent({ track }) {
  // const handleEnrolment = async () => {

  //   const payload = {
  //     product_id: track.id,
  //     product_external_id: Number(track.external_id),
  //     workload_value: track.workloads[0].workload_value,
  //     workload_id: track.workloads[0].workload_id,
  //     period_id: track.periods[0].id,
  //   }

  //   if (status !== 'authenticated') {
  //     payload.origin = 'vitrine'
  //     const queryString = new URLSearchParams(payload).toString();
  //     const url = `${process.env.NEXT_PUBLIC_PLATAFORM_URL}conta/login?${queryString}`
  //     return window.location.href = url
  //   }

  //   let enrolment = await fetch(process.env.NEXT_PUBLIC_BFF_API + 'notify/enrolment', {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(payload),
  //   })

  //   if (enrolment.ok) {
  //     enrolment = await enrolment.json()
  //     if(enrolment?.createRequestPayment){
  //       const { matricula_id, tipo_venda } = enrolment.requestPaymentData
  //       const url = `${process.env.NEXT_PUBLIC_PLATAFORM_URL}app/sala/curso/${track.external_id}?goToCard=true&matricula_id=${matricula_id}&tipo_venda=${tipo_venda}`
  //       return window.location.href = url
  //     }

  //     return window.location.href = `${process.env.NEXT_PUBLIC_PLATAFORM_URL}app/sala/curso/${track.external_id}`

  //   }

  // }

  return (
    <Button
      // onClick={handleEnrolment}
      asChild
      className="h-10 rounded-full font-bold text-[#EFE2F9] text-lg"
      style={{
        background:
          'linear-gradient(90deg, #E913FC 0%, #7302D5 49.56%, #E913FC 102.32%)',
      }}
    >
      <Link href="#buy">Comece a se capacitar</Link>
    </Button>
  )
}
